import { NgModule } from '@angular/core';
import { NotesModule } from '../../../components/notes/notes.module';
import { SharedModule } from '../../../shared/shared.module';
import { JobSummaryPreviewComponent } from './job-summary-preview.component';
import { EditableModule } from '@ngneat/edit-in-place';

@NgModule({
  declarations: [
    JobSummaryPreviewComponent
  ],
  imports: [
    SharedModule,
    NotesModule,
    EditableModule,
  ],
  exports:[
    JobSummaryPreviewComponent
  ]
})
export class JobSummaryPreviewModule { }
